/**
 * SP Announcement + Countdown Tracking with PostHog
 * (same wait-for-posthog pattern as sp-faq-tracking.js)
 *
 * Events:
 *   countdown_bar_viewed      — once per pageview where the bar rendered
 *                               {days_left, template}   (the denominator)
 *   countdown_cta_clicked     — the bar's "Learn more"  {days_left}
 *   countdown_menu_opened     — the hide menu opened  {days_left}
 *   countdown_dismissed       — {duration: 'today' | 'month', days_left}
 *   announcement_link_clicked — a link inside a rotating announcement
 *                               {href, message} (Autumn Living lives here)
 */

(function () {
  'use strict';
  if (window.__spQA == null) window.__spQA = (function () { var q = /[?&]sp_qa=([01])(?:&|$)/.exec(location.search), s = false; try { if (q) localStorage.setItem('sp_qa', q[1]); s = localStorage.getItem('sp_qa') === '1'; } catch (e) {} var r = window.Shopify && window.Shopify.theme && window.Shopify.theme.role; return s || /^(localhost|127\.0\.0\.1)$/.test(location.hostname) || /SimplePaperQA/.test(navigator.userAgent) || (!!r && r !== 'main'); })();

  function waitForPostHog(callback, maxAttempts = 50) {
    let attempts = 0;
    function checkPostHog() {
      attempts++;
      if (typeof window.posthog !== 'undefined') {
        callback();
      } else if (attempts < maxAttempts) {
        setTimeout(checkPostHog, 100);
      } else {
        console.warn('PostHog not available - SP announcement tracking disabled');
      }
    }
    checkPostHog();
  }

  function initAnnTracking() {
    try {
      const capture = (name, props) => {
        if (window.__spQA) return;
        try { window.posthog.capture(name, props); } catch (e) { /* never break the page */ }
      };

      // --- countdown timer bar ---
      const bar = document.querySelector('.sp-ann-timer');
      if (bar) {
        const barCtx = {
          days_left: parseInt(bar.getAttribute('data-sp-days-left'), 10),
          template: bar.getAttribute('data-sp-template') || undefined,
          // page path: lets us rank which pages collect the most dismissals
          // and tune the 21/12/4-day visibility tiers over time
          path: location.pathname,
        };

        // viewed = rendered AND not hidden by the dismiss cookie's early <style>
        if (bar.offsetParent !== null || bar.getClientRects().length > 0) {
          capture('countdown_bar_viewed', barCtx);
        }

        const cta = bar.querySelector('.sp-ann-timer__cta');
        if (cta) {
          cta.addEventListener('click', function () {
            capture('countdown_cta_clicked', barCtx);
          });
        }

        // menu opened: opened minus dismissed = people who looked at the hide choices and kept the bar
        // (brand touchpoint countdown-banner-hide, operator 2026-10-25)
        const menu = bar.querySelector('[data-sp-ann-timer-close-menu]');
        if (menu) {
          menu.addEventListener('toggle', function () {
            if (menu.open) capture('countdown_menu_opened', barCtx);
          });
        }

        bar.querySelectorAll('[data-sp-ann-timer-hide]').forEach(function (option) {
          option.addEventListener('click', function () {
            const raw = option.getAttribute('data-sp-ann-timer-hide');
            capture('countdown_dismissed', Object.assign({
              duration: raw === 'today' ? 'today' : 'month',
            }, barCtx));
          });
        });
      }

      // --- rotating announcement messages (Autumn Living link etc.) ---
      document.querySelectorAll('.announcement-bar .announcement a').forEach(function (link) {
        link.addEventListener('click', function () {
          const message = link.closest('.announcement');
          capture('announcement_link_clicked', {
            href: link.getAttribute('href'),
            path: location.pathname,
            message: message ? message.textContent.trim().slice(0, 120) : undefined,
          });
        });
      });
    } catch (error) {
      console.error('Error initializing SP announcement tracking:', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { waitForPostHog(initAnnTracking); });
  } else {
    waitForPostHog(initAnnTracking);
  }
})();
